import React from 'react';
import YunSection from '../YunSection/YunSection';
import './SwitchAccHelper.css';

/**
 * 当前播放器做不了某个功能时的「原位替换块」，两种形态：
 *   mode = 'acc'  → 一行提示 + 一个「切换伴奏助手」按钮（点一下切到伴奏助手模式）
 *   mode = 'hint' → 只显示一句提示文字（比如全民K歌要用户自己在全民里调升降调）
 *
 * features 支持传多个（升降调/消人声都不支持时合并成一个按钮，不重复显示两遍）
 */
const SwitchAccHelper = function(props) {
    const { mode, features, hint, onClick } = props;
    const names = (features || []).join('/');
    if (mode === 'hint') {
        return (
            <div className="SwitchAccHelper YunComponent">
                <YunSection width="200" height="33">
                    <div className="SwitchAccHelperLayout Center">
                        <span className="hint-only">{hint || ('请在播放器内调整' + names)}</span>
                    </div>
                </YunSection>
            </div>
        );
    }
    return (
        <div className="SwitchAccHelper YunComponent">
            <YunSection width="200" height="33">
                <div className="SwitchAccHelperLayout">
                    <div className="SwitchAccHelperText">
                        <span className="Label">{names}</span>
                    </div>
                    <div className="SwitchAccHelperBtn" onClick={onClick}>
                        <span>切换伴奏助手</span>
                    </div>
                </div>
            </YunSection>
        </div>
    );
};

export default SwitchAccHelper;
